// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./TrTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tr-module__Container__YB7wV {
    position: relative;
    display: flex;
    min-height: var(--ds-14x);
    border-radius: var(--ds-border-radius-sm);
    transition: background-color var(--ds-transition-s) ease-in-out;
}

.Tr-module__Container__YB7wV:hover {
    background-color: var(--ds-interaction-hover);
}

.Tr-module__Container__YB7wV:focus {
    background-color: var(--ds-interaction-hover);
    outline: none;
}

.Tr-module__HeadRow__sgnT6 {
    min-height: auto;
    margin: 0;
    background-color: transparent;
}

.Tr-module__HeadRow__sgnT6::after {
    bottom: 0;
}

.Tr-module__HeadRow__sgnT6:hover {
    background-color: transparent;
}

.Tr-module__HeadRow__sgnT6:focus {
    background-color: transparent;
}

.Tr-module__Odd__Lu_X8 {
    background-color: var(--ds-table-row-odd-bg-color);
}

.Tr-module__Selected__pAj9d {
    color: var(--ds-table-row-selected-color);
    background-color: var(--ds-interaction-select);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Tr-module__Container__YB7wV`,
	"HeadRow": `Tr-module__HeadRow__sgnT6`,
	"Odd": `Tr-module__Odd__Lu_X8`,
	"Selected": `Tr-module__Selected__pAj9d`
};
export default ___CSS_LOADER_EXPORT___;
